module.exports = __webpack_public_path__ + "img/queries-distribution.f561462a.gif";